import React from "react";
import { useLocation, useNavigate } from "react-router";
import useActionDialog from "../Provider/ActionDialogContext";
import { deferCall } from "../Functions/Helper/Async";

export default function useConfirmMessageDisplay() {
    const { search } = useLocation();
    const { confirm } = useActionDialog();
    const navigate  = useNavigate();
    React.useEffect(() => {
        const params = new URLSearchParams(search);
        const confirmMessage = params.get("confirm");
        if (confirmMessage) {
            params.delete("confirm");
            deferCall(() => navigate(`${window.location.pathname}?${params.toString()}`));
            confirm(confirmMessage).then((res) => {
                if (res === false && params.get("cancel")) {
                    deferCall(() => navigate(params.get("cancel")));
                }
            });
        }
    }, [search, navigate, confirm]);
}
